import React from "react"
import { Box, Typography, CardContent } from "@mui/material"
import styled from "styled-components"
import { Link } from "react-router-dom"

// Styled Card with responsive improvements
const Card = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #fff;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.2);
  }

  // Responsive behavior for different screen sizes
  @media (min-width: 768px) {
    max-width: 350px;
  }

  @media (min-width: 1200px) {
    max-width: 400px;
  }
`

const ImageContainer = styled.div`
  position: relative;
  height: 250px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 12px 12px 0 0;
  }
`

// Styled Tag with hover effects
const Tag = styled(Link)`
  display: inline-block;
  margin: 4px;
  padding: 6px 12px;
  background-color: #f5f5f5;
  color: #555;
  border-radius: 20px;
  font-size: 14px;
  text-decoration: none;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.08);
    background-color: #e0e0e0;
  }
`

// RecipeCard component definition
const RecipeCard = ({ recipe }) => {
  return (
    <Card to={`/recipe/${recipe._id}`}>
      <ImageContainer>
        <img
          src={recipe.thumbnail || "/default-image.jpg"}
          alt={recipe.title}
        />
      </ImageContainer>
      <CardContent>
        <Typography
          gutterBottom
          variant="h6"
          component="div"
          sx={{ fontWeight: "bold", textTransform: "capitalize" }}
        >
          {recipe.title}
        </Typography>
        <Box display="flex" flexWrap="wrap" gap="8px" mt={1}>
          {recipe.selectedTags?.map((tag, index) => (
            <Tag
              to={{
                pathname: "/search",
                search: `?tag=${tag}`,
              }}
              key={index}
            >
              {tag}
            </Tag>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default RecipeCard
